import React, { useEffect, useState } from "react";
import { getCodeFromUrl } from "../../../../../../utils/helper";
import { useSelector } from "react-redux";
import { getRenewalTitle } from "../../../../../../service/renewal/renewalService";
import { api_strapi } from "../../../../../../utils/interface";
import "./index.scss"

function WhyUs() {
  const [whyPolicyeraData, setWhyPolicyEraData] = useState([]);
  let agCode = getCodeFromUrl().toUpperCase();
  const renewalTitle = useSelector((state) => state.renewal.renewalTitles);

  useEffect(() => {
    const whyUs = async () => {
      const response = await api_strapi.get(
        `${process.env.REACT_APP_STRIPI_URL}/ags?filters[slug][$eq]=${agCode}&populate=why_policyeras,why_policyeras.icon`
      );
      if (response && response.status === 200) {
        setWhyPolicyEraData(
          response?.data?.data[0]?.attributes?.why_policyeras?.data
        );
      }
    };
    whyUs();
  }, [agCode]);

  useEffect(() => {
    const getTitles = async () => {
      await getRenewalTitle();
    };
    getTitles();
  }, []);

  return (
    <div className="whyus-container">
      <div className="whyus-header">{`${renewalTitle?.whyPolicyera} ${agCode} ?`}</div>
      <div className="benefits-container">
        {whyPolicyeraData?.map((item, index) => (
          <div className="benefit" key={index}>
            <div className="benefit-icon">
              <img
                className="img-fluid"
                src={item?.attributes?.icon?.data?.attributes?.url}
                alt={index}
              />
            </div>
            <div className="desc-container">
              <div className="benefit-title">{item?.attributes?.title}</div>
              <div className="benefit-desc">
                {item?.attributes?.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WhyUs;
